import React from "react";
import { MDCAnchorMenu,MDCButtonIcon,MDCMenu } from "../../library/components/mdc-components";

////page actions menu
export default class PagesMenu extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        var itemStyle = { display: 'none' };
        if (this.props.showSettings) itemStyle = {};
        return (
            <MDCAnchorMenu menuId="pagesMenu" onMenuSelected={this.props.onMenuSelected}>
                <MDCButtonIcon icon="pages" label="Pages" active={this.props.active} index="1" anchor="true" />
                {this.props.showFullMenu ? (
                    <MDCMenu disableInit="true" id="pagesMenu" cls="small">
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="page-create" data-id="page-create">Create Page</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="pages-view" data-id="pages-view">View Pages</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="page-settings" data-id="page-settings">Page Settings</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="page-delete" data-id="page-delete">Delete Page</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="manage-notification" data-id="manage-notification">Manage Notification Bar</li>
                        <li className="mdc-list-item hide" role="menuitem" tabIndex="0" data-value="dashboard" data-id="dashboard">View Dashboard</li>
                    </MDCMenu>
                ) : (
                    <MDCMenu disableInit="true" id="pagesMenu" cls="small">
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="page-create" data-id="page-create">Create Page</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="pages-view" data-id="pages-view">View Pages</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="page-settings" data-id="page-settings" style={itemStyle}>Page Settings</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-value="manage-notification" data-id="manage-notification">Manage Notification Bar</li>
                        <li className="mdc-list-item hide" role="menuitem" tabIndex="0" data-value="dashboard" data-id="dashboard">View Dashboard</li>
                    </MDCMenu>
                )}
            </MDCAnchorMenu>
        );
    }
}